import React from 'react'
import Icon from 'react-icon-base'

export default (props) => {
  return (
    <Icon viewBox='0 0 512 512' {...props}>
      <title id='Pause'>{props.title || 'Pause'}</title>
      <g><path d='M224 435.8v-359.7c0-6.7-5.4-12.1-12.2-12.1h-71.6c-6.8 0-12.2 5.4-12.2 12.1v359.7c0 6.7 5.4 12.2 12.2 12.2h71.6c6.8 0 12.2-5.4 12.2-12.2zM371.8 64h-71.6c-6.7 0-12.2 5.4-12.2 12.1v359.7c0 6.7 5.4 12.2 12.2 12.2h71.6c6.7 0 12.2-5.4 12.2-12.2v-359.7c0-6.7-5.4-12.1-12.2-12.1z' /></g>
    </Icon>
  )
}



// WEBPACK FOOTER //
// ./client/components/icons/pause.js